import { Link } from "react-router-dom";

interface Band {
  label: string;
  range: string;
  className: string;
  text?: string;
}

const bands: Band[] = [
  { label: "Excellent", range: "≥ 85", className: "bg-primary", text: "text-primary-foreground" },
  { label: "Strong", range: "78–84", className: "bg-primary/75", text: "text-primary-foreground" },
  { label: "Steady", range: "70–77", className: "bg-[hsl(var(--chart-2))]/70" },
  { label: "Watch", range: "62–69", className: "bg-[hsl(var(--chart-3))]/70" },
  { label: "Support", range: "< 62", className: "bg-[hsl(var(--chart-4))]/70" },
];

/** Compact legend for the Human Development heatmap. */
export default function HeatmapLegend() {
  return (
    <div className="flex flex-wrap items-center gap-2 pt-3 mt-3 border-t text-[11px]">
      <span className="schools-eyebrow mr-1">Legend</span>
      {bands.map((b) => (
        <span key={b.label} className="inline-flex items-center gap-1.5">
          <span className={`w-4 h-4 rounded ${b.className} ${b.text ?? ""} grid place-items-center text-[9px] font-semibold`}>
            {b.range.startsWith("≥") ? "★" : ""}
          </span>
          <span className="text-muted-foreground">
            <span className="font-medium text-foreground">{b.label}</span> · {b.range}
          </span>
        </span>
      ))}
      <Link to="/schools/glossary" className="ml-auto text-primary hover:underline">
        Glossary →
      </Link>
    </div>
  );
}
